/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { TourResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TourUserServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get user tours
     * 
     * @param userId 
     */
    getUserTours(userId?: string, extraHttpRequestParams?: any): Observable<Array<TourResource>>;

}
